<pdf-shy-button
  [action]="onClick"
  [toggled]="isSelected"
  [toggleButton]="true"
  primaryToolbarId="primaryCursorPageFlipTool"
  [cssClass]="showPageFlipButton() | responsiveCSSClass : 'hiddenXLView'"
  title="Enable page flip tool"
  l10nId="pdfjs-cursor-page-flip-tool-button"
  l10nLabel="pdfjs-cursor-page-flip-tool-button-label"
  [order]="1300"
  [disabled]="disable()"
  image="<svg aria-hidden='true' focusable='false' width='22px' height='22px' viewBox='0 0 24 24'><path fill='currentColor' d='M19 2L14 6.5V17.5L19 13V2M6.5 5C4.55 5 2.45 5.4 1 6.5V21.16C1 21.41 1.25 21.66 1.5 21.66C1.6 21.66 1.65 21.59 1.75 21.59C3.1 20.94 5.05 20.5 6.5 20.5C8.45 20.5 10.55 20.9 12 22C13.35 21.15 15.8 20.5 17.5 20.5C19.15 20.5 20.85 20.81 22.25 21.56C22.35 21.61 22.4 21.59 22.5 21.59C22.75 21.59 23 21.34 23 21.09V6.5C22.4 6.05 21.75 5.75 21 5.5V19C19.9 18.65 18.7 18.5 17.5 18.5C15.8 18.5 13.35 19.15 12 20V6.5C10.55 5.4 8.45 5 6.5 5Z'/></svg>"
>
</pdf-shy-button>
